export default "__VITE_ASSET__4c40d083__"